import _ from 'lodash';
import React, { PropTypes } from 'react';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import cx from 'classnames';
import { Link } from 'react-router';
import ModalForm from '../../common/components/c_ModalForm';
import TextField from '../../common/components/c_TextField';
import PasswordWithValidators from '../../common/components/f_PasswordWithValidators';
import { updatePassword, isResetRequestValid } from './../../redux/api/auth';
import { validate } from '../../modelValidator';
import { getSchema as getUserSchema } from '../../models/user';

const loginSchema = _.pick(getUserSchema(), 'password');

@connect((state, props) => {
  return {
    token: props.location.query.token
  };
})
export default class ChangePassword extends React.Component {
  static propTypes = {
    token: PropTypes.string,
    dispatch: PropTypes.func
  }

  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
      password: {
        value : '',
        dirty : false
      },
      confirm: {
        value: '',
        dirty: false
      },
      step: this.FORM,
      error: false
    };
  }

  componentWillMount() {
    if (!this.props.token) {
      return this.props.dispatch(push(this.resetUrl));
    }

    isResetRequestValid(this.props.token)
      .catch(() => this.props.dispatch(push(this.resetUrl)));
  }

  resetUrl = '/forgotpassword'
  loginUrl = '/login'

  FORM = 0
  SUBMIT = 1
  COMPLETE = 2

  cloneState() {
    return _.merge({}, this.state);
  }

  handleSubmit = () => {
    this.setState({...this.setState, step: this.SUBMIT});
    updatePassword(this.props.token, this.state.password.value)
      .then(() => this.setState({...this.state, step: this.COMPLETE}))
      .catch(() => this.setState({...this.state, error: true, step: this.FORM}));
  }

  handleClose = () => {
    this.props.dispatch(push('/'));
  }

  handlePasswordChange = (event) => {
    const newState = this.cloneState();
    newState.password.value = event.target.value;
    newState.password.dirty = true;
    newState.error = false;
    this.setState(newState);
  }

  handleConfirmChange = (event) => {
    const newState = this.cloneState();
    newState.confirm.value = event.target.value;
    newState.confirm.dirty = true;
    newState.error = false;
    this.setState(newState);
  }

  handleConfirmBlur = () => {
    const newState = this.cloneState();
    newState.confirm.dirty = true;
    this.setState(newState);
  }

  renderForm() {
    return (
      <div className='password-entry'>
        <PasswordWithValidators value={this.state.password.value}
                                onChange={this.handlePasswordChange}/>
        <TextField className='full-width'
                   floatingLabelText='Confirm Password'
                   data-id='Confirm Password'
                   password
                   onChange={this.handleConfirmChange}
                   onBlur={this.handleConfirmBlur}
                   errorText={this.state.confirm.dirty &&
                              this.state.confirm.value !== this.state.password.value &&
                              'Please make sure both password entries are the same' || undefined}/>
        <div className={cx('error-message', {opaque: this.state.error})}>
          Ooops, something went wrong.
        </div>
      </div>
    );
  }

  renderSent() {
    return (
      <div className='password-message'>
        <hr className='message-divider'/>
        <div className='already-exists-section'>
          While we update your password.
        </div>
      </div>
    );
  }

  renderComplete() {
    return (
      <div className='password-message'>
        <hr className='message-divider'/>
        <div className='welcome-body message-body'>
          Your password was successfully reset. Please <Link className='link' to='/login'>sign in</Link> using your new password.
        </div>
      </div>
    );
  }

  render() {

    const isNotForm = (this.state.step !== this.FORM);
    const isNotValid = (validate({password: this.state.password.value}, loginSchema).length);
    const isNotMatch = !(this.state.password.value && this.state.confirm.value === this.state.password.value);
    let prompt = '';
    let promptStyle = 'reset-form';

    switch(this.state.step) {
      case this.SUBMIT:
        prompt = 'Please wait';
        break;
      case this.COMPLETE:
        prompt = 'Success!';
        promptStyle = 'reset-form-success';
        break;
      default:
        prompt = 'Change Password';
    }

    return (
      <div>
        <ModalForm className={promptStyle}
                   prompt={prompt}
                   onClose={this.handleClose}
                   button={{
                      label: 'Submit',
                      onClick: this.handleSubmit,
                      disabled: isNotForm ||
                                isNotValid ||
                                isNotMatch
                  }}>

        {
          (this.state.step === this.FORM)
          &&
          this.renderForm()
            ||
          (this.state.step === this.SUBMIT)
          &&
          this.renderSent()
            ||
          (this.state.step === this.COMPLETE)
          &&
          this.renderComplete()
        }
        {
          this.props.children
        }
        </ModalForm>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/public/ChangePassword.js